/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

class ProfileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
    }));
  }

  render() {
    const {
      columns, manageColumns, isColumnVisible, isColumnFixed,
    } = this.props;
    return (
      <Dropdown
        isOpen={this.state.menu}
        toggle={this.toggle}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <i className="mdi mdi-filter-variant me-2" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {Object.keys(columns).filter((colKey) => !isColumnFixed(colKey)).map((colKey) => {
            const colConfig = columns[colKey];
            const isVisible = isColumnVisible(colKey);
            return (
              <DropdownItem key={colKey} tag="div">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={isVisible}
                  onChange={() => manageColumns(colKey, isVisible ? 0 : 1)}
                  id={`col-toggle-${colKey}`}
                  style={{ cursor: 'pointer' }}
                />
                <label
                  htmlFor={`col-toggle-${colKey}`}
                  style={{ cursor: 'pointer', marginBottom: 0 }}
                >
                  {this.props.t(colConfig.label || colKey)}
                </label>
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

ProfileMenu.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
  columns: PropTypes.object,
  manageColumns: PropTypes.func,
  isColumnVisible: PropTypes.func,
  isColumnFixed: PropTypes.func,
};

const mapStateToProps = () => ({ });

export default withRouter(
  connect(mapStateToProps, {})(withTranslation()(ProfileMenu)),
);
